import React, {useEffect, useState} from "react"
import {Container} from "./component"
import {CONTENT_AREA, MAIN_CONTENT, PDP_ENTRYPOINT_ID, PLP_ENTRYPOINT_ID} from "../../config/constants"
import connect from "./connect"

export const SkipContent = ({text}) => {
    const [mounted, setMounted] = useState<boolean>(false)
    let res

    useEffect(() => {
        res =
            document.querySelector<HTMLInputElement>(`#${PLP_ENTRYPOINT_ID}`) ||
            document.querySelector<HTMLInputElement>(`#${CONTENT_AREA}`) ||
            document.querySelector<HTMLInputElement>(`#${MAIN_CONTENT}`) ||
            document.querySelector<HTMLInputElement>(`#${PDP_ENTRYPOINT_ID}`)
        if (res) {
            setMounted(true)
        }
    }, [])

    const handleSkipKeyboard = e => {
        if (e.key === "Enter") {
            if (res) {
                res.tabIndex = 0
                res?.focus()
            }
        }
    }

    const handleSkipClick = () => {
        res.tabIndex = 0
        res.focus()
    }

    if (!mounted) return null

    return (
        <Container
            id="next-header-skip-to-content"
            data-testid="next-header-skip-to-content"
            tabIndex={0}
            onKeyDown={handleSkipKeyboard}
            onClick={handleSkipClick}
            aria-label={text.skipToMainContent}
        >
            {text.skipToMainContent}
        </Container>
    )
}

export default connect(SkipContent)
